import React from 'react';

import Switch from '~/core/scripts/components/Switch';

export default ({ checked, onToggle }) => {
  if (ARTICLE_CONFIG.isLive) {
    return null;
  }

  return (
    <div className="modeswitch">
      <div className="modeswitch__label start">Modus:</div>
      <div className="modeswitch__label left" onClick={() => onToggle(false)}>
        Stadtteile
      </div>
      <Switch checked={checked} onChange={checked => onToggle(checked)} />
      <div className="modeswitch__label right" onClick={() => onToggle(true)}>
        Wahllokale
      </div>
    </div>
  );
};
